export default "__VITE_ASSET__xxH_jkC7__"